import { formatTime } from "@/utils/time";

export const PRINT_SETUP = {
  pId: "00000000-0000-0000-0000-000000000000",
  key: 1,
  ztid: "00000000-0000-0000-0000-000000000000",
  printSettings: {
    left: 0,
    top: 0,
    pageCount: 0,
    countPrice: true,
    accounting: true,
    direction: true,
    date: true,
    page: true,
    entryCount: 0,
    currentaccount: true,
    voucherID: "00000000-0000-0000-0000-000000000000",
    printDate: "2020-06-23T01:34:38.502Z",
    showLJ: true,
    wagesPrintId: "",
    details: "",
    summary: "",
    fullNumber: true,
    accountLevel: 0,
  },
  id: 0,
};

export const getPrintDefault = () => ({
  id: 0,
  printSettings: {
    accountLevel: 0, // 科目等级
    accounting: true,
    countPrice: true,
    currentaccount: true,
    date: true, // 显示日期
    details: null,
    direction: true, // true横向；false纵向
    entryCount: 0,
    fullNumber: false,
    left: 0, // 居左长度毫米
    page: true, // 显示页码
    PageCount: 0, //// 每页凭证数据
    printDate: formatTime(new Date()), // 打印日期
    showTotal: true, //始终显示本月合计、本年累计
    summary: null,
    top: 0, // 居上长度毫米
    voucherID: "00000000-0000-0000-0000-000000000000",
    wagesPrintId: null,
    summaryTag: false,
    printAssistingAccountTag: false, // 挂辅助核算的科目不打印
    summaryInventoryAccountTag: false, // 挂存货辅助核算科目同科目同方向金额汇总
    printCoverTag: false, // 打印封面
    LedgerPrintId: 0,
    fontSize: 14,
    startPeriod: 0, //开始期间
    endPeriod: 0, // 结束期间
    showPerson: true, //人员显示
    charger: "", //单位负责人
    financeCharger: "", //财务负责人
    tooReview: "", //复核人
    maker: "", //制表人
    isShowCpdBalance: true, //本期金额
    isShowLCpdBalance: false, //上期金额
    isShowYtdBalance: true, //本年累计,
  }, // 打印设置
});
